export default "__VITE_ASSET__H8_oxSua__"